var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "de-container",
    [
      _c(
        "de-aside-container",
        { attrs: { type: "panel" } },
        [
          _c(
            "el-tabs",
            {
              staticClass: "tab-panel",
              attrs: { stretch: true },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              !_vm.$route.meta.isPanelShar
                ? _c(
                    "el-tab-pane",
                    { attrs: { name: "PanelList" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", {
                          staticClass: "el-icon-document tablepanel-i",
                        }),
                        _vm._v(_vm._s(_vm.$t("panel.panel_list"))),
                      ]),
                      _c("panel-list", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.activeName === "PanelList",
                            expression: "activeName==='PanelList'",
                          },
                        ],
                        ref: "panelList",
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.$route.meta.isPanelShar
                ? _c(
                    "el-tab-pane",
                    { attrs: { name: "panels_star", lazy: true } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", {
                          staticClass: "el-icon-star-off tablepanel-i",
                        }),
                        _vm._v(_vm._s(_vm.$t("panel.store"))),
                      ]),
                      _vm.activeName === "panels_star"
                        ? _c("enshrine")
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$route.meta.isPanelShar
                ? _c(
                    "el-tab-pane",
                    { attrs: { name: "panels_share", lazy: true } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", { staticClass: "el-icon-share tablepanel-i" }),
                        _vm._v(_vm._s(_vm.$t("panel.share"))),
                      ]),
                      _vm.showShare
                        ? _c("share-tree", {
                            ref: "share_tree",
                            attrs: { "msg-panel-ids": _vm.msgPanelIds },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "de-main-container",
        [
          _vm.mainActiveName === "PanelMain"
            ? _c("PanelViewShow", {
                attrs: { "active-tab": _vm.activeName },
                on: {
                  editPanel: _vm.editPanel,
                  editPanelBashInfo: _vm.editPanelBashInfo,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }